/* ==========================================================================
   THEME SWITCHER MODULE (CLEAN SVG ICONS)
   ========================================================================== */

const sunSvg = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="5"></circle><line x1="12" y1="1" x2="12" y2="3"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line><line x1="1" y1="12" x2="3" y2="12"></line><line x1="21" y1="12" x2="23" y2="12"></line><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line></svg>`;

const moonSvg = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path></svg>`;

let currentTheme = localStorage.getItem('hba_theme') || 'light';

export function initThemeSwitcher() {
  const themeToggles = document.querySelectorAll('.theme-toggle');

  // Set initial theme state
  applyTheme(currentTheme);

  themeToggles.forEach(toggle => {
    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      currentTheme = currentTheme === 'light' ? 'dark' : 'light';
      localStorage.setItem('hba_theme', currentTheme);
      applyTheme(currentTheme);
    });
  });
}

export function applyTheme(theme) {
  document.documentElement.setAttribute('data-theme', theme);
  
  const themeToggles = document.querySelectorAll('.theme-toggle');
  const headerLogo = document.querySelector('.site-header .logo-image');

  // Update button SVG icon (no raw emojis)
  themeToggles.forEach(toggle => {
    const iconEl = toggle.querySelector('.theme-icon') || toggle;
    if (theme === 'dark') {
      iconEl.innerHTML = sunSvg;
      toggle.setAttribute('title', 'Switch to Light Theme');
      toggle.setAttribute('aria-label', 'Switch to Light Theme');
    } else {
      iconEl.innerHTML = moonSvg;
      toggle.setAttribute('title', 'Switch to Dark Theme');
      toggle.setAttribute('aria-label', 'Switch to Dark Theme');
    }
  });

  // Swap transparent original logo for contrast
  if (headerLogo) {
    if (theme === 'dark') {
      headerLogo.src = '/images/hopebase-logo-original-white.png';
    } else {
      headerLogo.src = '/images/hopebase-logo-original.png';
    }
  }
}
